import { FC, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import RequireAuth from '../../hoc/RequireAuth';
import { useTranslates } from '../../providers/translates';
import { routs } from '../../routs';
import Layout from '../Layout';

import { isVac } from 'utilities/is-vac';
import { Helmet } from 'react-helmet-async';
import TagManager from 'react-gtm-module';
import { GTM_ID } from 'config';


interface AppRouterProps {}

const AppRouter: FC<AppRouterProps> = () => {
  const { translates } = useTranslates();
  useEffect(() => {
    const gtmId = GTM_ID;
    if (gtmId) {
      TagManager.initialize({ gtmId });
    }
  }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          {routs.map((route) =>
            route.isPrivate ? (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <RequireAuth>
                    <route.element />
                  </RequireAuth>
                }
              />
            ) : (
              <Route key={route.path} path={route.path} element={<route.element />} />
            )
          )}
          <Route
            path="*"
            element={
              <div style={{ textAlign: 'center' }}>
                {translates?.pageNotFound || 'Page not found'}               
              </div>
            }
          />          
        </Route>        
      </Routes>
      {isVac() && (
        <Helmet>
          <meta name="description" content={`${translates?.description || 'Saluting Service'}`} />
          <title>{translates?.title || 'Saluting Service'}</title>
        </Helmet>
      )}
    </>
  );
};

export default AppRouter;
